<template>
  <a-form :form="form" @submit="handleSubmit">
    <a-row>
      <a-row>
        <a-col :span="11">
          <a-form-item label="单位部门编码">
            <a-input v-decorator="[
              'deptCode',
              { rules: [{ required: true, message: '请输入编码!' }, { max: 8, message: '字段长度过长！' }] }]"
              placeholder="请输入编码!" />
          </a-form-item>
        </a-col>
        <a-col :span="2">
        </a-col>
        <a-col :span="11">
          <a-form-item label="单位部门名称">
            <a-input v-decorator="[
              'deptName',
              { rules: [{ required: true, message: '请输入单位部门名称!' }, { max: 100, message: '字段长度过长！' }] }]"
              placeholder="请输入单位部门名称" />
          </a-form-item>
        </a-col>
      </a-row>

      <a-form-item label="上级部门">
        <a-tree-select v-decorator="[
          'sjDeptCode',
          { rules: [{ required: true, message: '请选择上级部门!' }] }]" show-search
          :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }" placeholder="请选择部门" :tree-data="treeData"
          :treeDefaultExpandedKeys="expandedKeys" treeNodeFilterProp="title">
        </a-tree-select>
      </a-form-item>

      <a-row>
        <a-col :span="11">
          <a-form-item label="部门领导集中人力编码">
            <a-input v-decorator="[
              'principal',
              { rules: [{ required: true, message: '请输入领导人力编码!' }, { max: 8, message: '字段长度过长！' }] }]"
              placeholder="请输入领导人力编码!" />
          </a-form-item>
        </a-col>
        <a-col :span="2">
        </a-col>
        <a-col :span="11">
          <a-form-item label="单位部门简称">
            <a-input v-decorator="[
              'shortname',
              { rules: [{ required: true, message: '请输入单位部门简称!' }, { max: 100, message: '字段长度过长！' }] }]"
              placeholder="请输入单位部门简称!" />
          </a-form-item>
        </a-col>
      </a-row>

      <a-row>
        <a-col :span="11">
          <a-form-item label="组织类型">
            <!-- :disabled="disabled" -->
            <a-input v-decorator="[
              'deptGlbdef3Desc',
              { rules: [{ required: true, message: '请输入单位部门类型!' }, { max: 100, message: '字段长度过长！' }] }]"
              placeholder="请输入单位部门类型!" />
          </a-form-item>
        </a-col>
        <a-col :span="2">
        </a-col>
        <a-col :span="11">
          <a-form-item label="上级机构内排序">
            <a-input-number id="inputNumber" style="width: 110px;"
              v-decorator="['displayOrder', { rules: [{ required: true, message: '请输排序数字!' }] }]" :min="1" :max="100" />
          </a-form-item>
        </a-col>
      </a-row>

    </a-row>
  </a-form>
</template>
<script>
import bus from "../../common/bus";
export default {
  props: {
    currdata: {
      type: Object,
      default: () => {
        return {};
      },
    },
    sjDeptCode: {
      type: String,
      default: ''
    },
    treeData: {
      type: Array,
      default: () => {
        return [];
      },
    }
  },
  data() {
    return {
      disabled: false,
      errorM: false,
      errorU: false,
      form: this.$form.createForm(this, { name: "deptForm" }),
      expandedKeys: [],
    };
  },
  created() {
    bus.$on("ModalSubmit", this.handleSubmit);
  },
  mounted() {
    let currdata2 = {};
    if (this.currdata.dept_code) {
      currdata2.deptCode = this.currdata.dept_code;
      currdata2.deptName = this.currdata.dept_name;
      currdata2.sjDeptCode = this.currdata.sj_dept_code;
      this.expandedKeys = [this.currdata.sj_dept_code]
      currdata2.displayOrder = this.currdata.display_order;
      currdata2.shortname = this.currdata.shortname;
      currdata2.deptGlbdef3Desc = this.currdata.dept_glbdef3_desc;
      currdata2.principal = this.currdata.principal;
      currdata2.createTime = this.currdata.create_time;
      currdata2.updateTime = this.currdata.update_time;
    }
    this.form.setFieldsValue(currdata2);
    if (this.currdata.dept_code) {
      this.disabled = true;
    } else {
      this.disabled = false;
    }

  },
  methods: {
    handleSubmit(e) {
      var this_ = this;
      if (e) e.preventDefault();
      if (this.errorM || this.errorU) {
        this_.$emit("callbackErr");
        return;
      }
      this.form.validateFields((err, values) => {
        if (!err || (this.currdata.dept_code && Object.keys(err).join('') == 'dept_code')) {
          let data = values;
          data.department = {};
          data.department.sjDeptCode = data.sjDeptCode ? data.sjDeptCode : this.currdata.department.sjDeptCode;
          if (this.currdata.dept_code) {
            data.deptCode = this.currdata.dept_code;
            data.createTime = this.currdata.create_time;
            this.axios.post("web/department/update", data).then(() => {
              this_.$emit("callback");
              this.$message.success("修改成功!")
            });
          } else {
            this.axios.post("web/department/insert", data).then(() => {
              this_.$emit("callback");
              this.$message.success("添加成功!")
            });
          }
        } else {
          this_.$emit("callbackErr");
        }
      });
    },
    // 以下是部门树相关


  },
  destroyed() {
    bus.$off("ModalSubmit");
  },
};
</script>